import React, { Component } from 'react';
import Link from 'gatsby-link';
import Helmet from 'gatsby-plugin-react-helmet';
import styled from 'styled-components';
import Navigation from '../componenten/Navigation';
import ProjectSummary from '../componenten/ProjectSummary';
import { ProjectImage, ProjectWrapper } from '../static/styles/styles';

const Sticky = styled.div`
  position: sticky;
  background-color: #fff;
  top: 160px;
  z-index: 3;
`;

const Template = ({ data, location, pathContext }) => {
  const navItems = data.allNavigationJson.edges;
  const subProjectItems = navItems.filter(
    ({ node: navItem }, index) => index === 0
  );
  const projects = data.allProjectenJson.edges[0];
  const project = projects.node.projecten.filter(
    prjct => pathContext.id === prjct.id
  )[0];
  return (
    <div>
      <Sticky>
        <Navigation items={subProjectItems} navType="sub" />
      </Sticky>
      <ProjectWrapper>
        <ProjectSummary projectData={project} />
        {project.afbeeldingen && project.afbeeldingen.map((afbeelding, index) => (
          <ProjectImage key={index} src={afbeelding.image} alt="" />
        ))}
      </ProjectWrapper>
    </div>
  );
};

export const pageQuery = graphql`
  query Query {
    allNavigationJson {
      edges {
        node {
          to
          name
          key
          sub
          subItems {
            to
            name
            key
          }
        }
      }
    }
    allProjectenJson {
      edges {
        node {
          projecten {
            id
            type
            name
            frontImage
            wie
            wat
            waar
            wanneer
            afbeeldingen {
              image
            }
          }
        }
      }
    }
  }
`;

export default Template;



// WEBPACK FOOTER //
// ./src/templates/project-tpl.js